import { render, staticRenderFns } from "./DigitalRecordManagementAddEdit.vue?vue&type=template&id=5126d63e"
import script from "./DigitalRecordManagementAddEdit.vue?vue&type=script&lang=js"
export * from "./DigitalRecordManagementAddEdit.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports